//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export class ReportRequestVm {
    motivation : string;
    appUserIdentifier : string;
    matchIdentifier : string;
    experienceIdentifier : string;
    matchQuestionIndex : number;

    constructor() 
    {
    	            this.motivation = "" ;
                this.appUserIdentifier = "" ;
                this.matchIdentifier = "" ;
                this.experienceIdentifier = "" ;
                this.matchQuestionIndex = null ;
        }
}

export class CloseAbuseVm {
    note : string;
    abuseIdentifier : string;
    blockUser : boolean;
    deleteUser : boolean;
    deleteExperience : boolean;

    constructor() 
    {
    	            this.note = "" ;
                this.abuseIdentifier = "" ;
                this.blockUser = false ;
                this.deleteUser = false ;
                this.deleteExperience = false ;
        }
}

export class PagedResponseOfAbuseRequest {
    items : AbuseRequest[];
    totalItemsCount : number;

    constructor() 
    {
    	            this.items = [];
                this.totalItemsCount = null ;
        }
}

export class SimpleEntity {
    identifier : string;

    constructor() 
    {
    	            this.identifier = "" ;
        }
}

export class BaseEntity extends SimpleEntity {
    createdOn : string ;
    modifiedOn : string ;

    constructor() 
    {
    	        super();
		            this.createdOn = null;
                this.modifiedOn = null;
        }
}

export class AbuseRequest extends BaseEntity {
    appUserIdentifier : string;
    managedOn : string ;
    note : string;
    isBlocked : boolean;
    isUserDeleted : boolean;
    isExperienceDeleted : boolean;
    details : AbuseDetail[];

    constructor() 
    {
    	        super();
		            this.appUserIdentifier = "" ;
                this.managedOn = null;
                this.note = "" ;
                this.isBlocked = false ;
                this.isUserDeleted = false ;
                this.isExperienceDeleted = false ;
                this.details = [];
        }
}

export class AbuseDetail {
    signalerIdentifier : string;
    matchIdentifier : string;
    experienceIdentifier : string;
    matchQuestionIndex : number;
    motivation : string;
    signaledOn : string ;

    constructor() 
    {
    	            this.signalerIdentifier = "" ;
                this.matchIdentifier = "" ;
                this.experienceIdentifier = "" ;
                this.matchQuestionIndex = null ;
                this.motivation = "" ;
                this.signaledOn = null;
        }
}

export class AbuseRequestDetailVm {
    signaler : TextIdentifier;
    signaled : TextIdentifier;
    chatRoomVM : ChatRoomVM;
    messages : ChatMessage[];
    profileSummaryVM : ProfileSummaryVM;
    matchVM : NewMatchVm;
    backofficeExperienceDetailVM : BackofficeExperienceDetailVM;

    constructor() 
    {
    	            this.signaler = new TextIdentifier();
                this.signaled = new TextIdentifier();
                this.chatRoomVM = new ChatRoomVM();
                this.messages = [];
                this.profileSummaryVM = new ProfileSummaryVM();
                this.matchVM = new NewMatchVm();
                this.backofficeExperienceDetailVM = new BackofficeExperienceDetailVM();
        }
}

export class TextIdentifier {
    text : string;
    identifier : string;

    constructor() 
    {
    	            this.text = "" ;
                this.identifier = "" ;
        }
}

export class ChatRoomVM {
    chatRoomIdentifier : string;
    matchIdentifier : string;
    affinityIdentifier : string;
    experienceIdentifier : string;
    myMatch : ChatRoomMatchSummaryVM;
    otherMatch : ChatRoomMatchSummaryVM;
    sender : ChatSender;
    lastMessage : ChatMessage;
    affinity : number;
    ghostingLevel : GhostingLevel;

    constructor() 
    {
    	            this.chatRoomIdentifier = "" ;
                this.matchIdentifier = "" ;
                this.affinityIdentifier = "" ;
                this.experienceIdentifier = "" ;
                this.myMatch = new ChatRoomMatchSummaryVM();
                this.otherMatch = new ChatRoomMatchSummaryVM();
                this.sender = new ChatSender();
                this.lastMessage = new ChatMessage();
                this.affinity = null ;
                this.ghostingLevel = null;
        }
}

export class ChatRoomMatchSummaryVM {
    replierIdentifier : string;
    matchIdentifier : string;
    isCompleted : boolean;

    constructor() 
    {
    	            this.replierIdentifier = "" ;
                this.matchIdentifier = "" ;
                this.isCompleted = false ;
        }
}

export class ChatSender {
    appUserIdentifier : string;
    profileUrl : string;
    profileName : string;
    birthDate : string ;

    constructor() 
    {
    	            this.appUserIdentifier = "" ;
                this.profileUrl = "" ;
                this.profileName = "" ;
                this.birthDate = null;
        }
}

export class ChatMessage extends BaseEntity {
    chatRoomIdentifier : string;
    senderIdentifier : string;
    text : string;
    disabledData : DisabledData;
    utcDatetime : string ;
    strictType : string;

    constructor() 
    {
    	        super();
		            this.chatRoomIdentifier = "" ;
                this.senderIdentifier = "" ;
                this.text = "" ;
                this.disabledData = new DisabledData();
                this.utcDatetime = null;
                this.strictType = "" ;
        }
}

export class DisabledData {
    disabledOn : string ;
    disabledBy : TextIdentifier;

    constructor() 
    {
    	            this.disabledOn = null;
                this.disabledBy = new TextIdentifier();
        }
}

export enum GhostingLevel {
    NoGhosting = 0,
    GhostingLevel1 = 1,
    GhostingLevel2 = 2,
}

export class ProfileSummaryVM {
    name : string;
    birthDate : string ;
    sexualOrientation : string;
    biography : string;
    identifier : string;
    minimumAffinityRate : number;
    questions : ProfileSummaryQuestionVM[];

    constructor() 
    {
    	            this.name = "" ;
                this.birthDate = null;
                this.sexualOrientation = "" ;
                this.biography = "" ;
                this.identifier = "" ;
                this.minimumAffinityRate = null ;
                this.questions = [];
        }
}

export class ProfileSummaryQuestionVM {
    question : string;
    answers : string[];
    noBlurQuestionImageUrl : string;

    constructor() 
    {
    	            this.question = "" ;
                this.answers = [];
                this.noBlurQuestionImageUrl = "" ;
        }
}

export class BaseMatchVm {
    distanceMeters : number;
    sexualOrientation : string;
    minimumAffinityRate : number;
    affinityPercentage : number;
    isOverMinimumAffinity : boolean;
    isBombTriggered : boolean;
    replierHasToConfirmAffinity : boolean;
    questions : NewMatchQuestion[];
    status : ReplyStatus;

    constructor() 
    {
    	            this.distanceMeters = null ;
                this.sexualOrientation = "" ;
                this.minimumAffinityRate = null ;
                this.affinityPercentage = null ;
                this.isOverMinimumAffinity = false ;
                this.isBombTriggered = false ;
                this.replierHasToConfirmAffinity = false ;
                this.questions = [];
                this.status = null;
        }
}

export class NewMatchVm extends BaseMatchVm {
    matchIdentifier : string;
    appUserIdentifier : string;
    chatRoomIdentifier : string;
    birthDate : string ;
    personName : string;
    biography : string;
    affinityRateReachedFromOther : number;
    isSecondChance : boolean;
    hasAnyExperience : boolean;
    tryAgainAlreadyUsed : boolean;
    needTryAgain : boolean;

    constructor() 
    {
    	        super();
		            this.matchIdentifier = "" ;
                this.appUserIdentifier = "" ;
                this.chatRoomIdentifier = "" ;
                this.birthDate = null;
                this.personName = "" ;
                this.biography = "" ;
                this.affinityRateReachedFromOther = null ;
                this.isSecondChance = false ;
                this.hasAnyExperience = false ;
                this.tryAgainAlreadyUsed = false ;
                this.needTryAgain = false ;
        }
}

export class BaseQuestion {
    question : string;
    answers : string[];
    minPercentage : number;

    constructor() 
    {
    	            this.question = "" ;
                this.answers = [];
                this.minPercentage = null ;
        }
}

export class NewMatchQuestion extends BaseQuestion {
    blurredImageUrl : string;
    noBlurImageUrl : string;
    imageUrl : string;
    answerIndex : number;
    affinityPercentage : number;
    disabledAnswersIndex : number[];
    answersPercentage : number[];

    constructor() 
    {
    	        super();
		            this.blurredImageUrl = "" ;
                this.noBlurImageUrl = "" ;
                this.imageUrl = "" ;
                this.answerIndex = null ;
                this.affinityPercentage = null ;
                this.disabledAnswersIndex = [];
                this.answersPercentage = [];
        }
}

export enum ReplyStatus {
    Created = 0,
    Started = 1,
    Completed = 2,
    Refused = -1,
}

export class ExperienceDetailVM {
    experienceIdentifier : string;
    creator : TextIdentifier;
    creatorBirthDate : string ;
    category : ExperienceCategory;
    period : TitleDatePeriod;
    address : UserAddress;
    title : string;
    description : string;
    biography : string;
    sexualOrientation : string;
    minimumAffinityPercentage : number;
    audioSrc : string;
    isExpired : boolean;
    isSecondChance : boolean;
    distanceMeters : number;

    constructor() 
    {
    	            this.experienceIdentifier = "" ;
                this.creator = new TextIdentifier();
                this.creatorBirthDate = null;
                this.category = new ExperienceCategory();
                this.period = new TitleDatePeriod();
                this.address = new UserAddress();
                this.title = "" ;
                this.description = "" ;
                this.biography = "" ;
                this.sexualOrientation = "" ;
                this.minimumAffinityPercentage = null ;
                this.audioSrc = "" ;
                this.isExpired = false ;
                this.isSecondChance = false ;
                this.distanceMeters = null ;
        }
}

export class MyExperienceDetailVM extends ExperienceDetailVM {
    approvedData : ApprovedData;
    applicants : ApplicantVM[];

    constructor() 
    {
    	        super();
		            this.approvedData = new ApprovedData();
                this.applicants = [];
        }
}

export class BackofficeExperienceDetailVM extends MyExperienceDetailVM {
    disabledData : DisabledData;
    preferredCulture : string;
    createdOn : string ;

    constructor() 
    {
    	        super();
		            this.disabledData = new DisabledData();
                this.preferredCulture = "" ;
                this.createdOn = null;
        }
}

export class ApprovedData {
    approvedOn : string ;
    refusedOn : string ;
    submittedOn : string ;
    refusedFor : string;
    approvedBy : TextIdentifier;

    constructor() 
    {
    	            this.approvedOn = null;
                this.refusedOn = null;
                this.submittedOn = null;
                this.refusedFor = "" ;
                this.approvedBy = new TextIdentifier();
        }
}

export class ApplicantVM {
    appUserIdentifier : string;
    imageUrl : string;
    appUserName : string;
    affinityIdentifier : string;
    affinityPercentage : number;
    matchCompleted : boolean;
    chatRoomIdentifier : string;

    constructor() 
    {
    	            this.appUserIdentifier = "" ;
                this.imageUrl = "" ;
                this.appUserName = "" ;
                this.affinityIdentifier = "" ;
                this.affinityPercentage = null ;
                this.matchCompleted = false ;
                this.chatRoomIdentifier = "" ;
        }
}

export class ExperienceCategory extends BaseEntity {
    iconUrl : string;
    title : LocalizedValue;

    constructor() 
    {
    	        super();
		            this.iconUrl = "" ;
                this.title = new LocalizedValue();
        }
}

export class LocalizedValue {
    values : { [key: string]: string; };

    constructor() 
    {
    	            this.values = {};
        }
}

export class TitleDatePeriod {
    title : string;
    period : DatePeriod;

    constructor() 
    {
    	            this.title = "" ;
                this.period = new DatePeriod();
        }
}

export class DatePeriod {
    start : string ;
    end : string ;
    duration : string;

    constructor() 
    {
    	            this.start = null;
                this.end = null;
                this.duration = "" ;
        }
}

export class Address {
    name : string;
    typedAddress : string;
    streetNumber : string;
    route : string;
    locality : string;
    province : string;
    region : string;
    country : string;
    countryCode : string;
    postalCode : string;
    latitude : number;
    longitude : number;
    completeAddress : string;

    constructor() 
    {
    	            this.name = "" ;
                this.typedAddress = "" ;
                this.streetNumber = "" ;
                this.route = "" ;
                this.locality = "" ;
                this.province = "" ;
                this.region = "" ;
                this.country = "" ;
                this.countryCode = "" ;
                this.postalCode = "" ;
                this.latitude = null ;
                this.longitude = null ;
                this.completeAddress = "" ;
        }
}

export class UserAddress extends Address {
    addressFixed : boolean;

    constructor() 
    {
    	        super();
		            this.addressFixed = false ;
        }
}

export class PagedResponseOfActivePlaceVM {
    items : ActivePlaceVM[];
    totalItemsCount : number;

    constructor() 
    {
    	            this.items = [];
                this.totalItemsCount = null ;
        }
}

export class ActivePlaceVM {
    identifier : string;
    type : ActivePlaceType;
    address : Address;
    isPublished : boolean;
    onboardingConfiguration : OnboardingConfiguration;

    constructor() 
    {
    	            this.identifier = "" ;
                this.type = null;
                this.address = new Address();
                this.isPublished = false ;
                this.onboardingConfiguration = new OnboardingConfiguration();
        }
}

export enum ActivePlaceType {
    Locality = 0,
    Province = 1,
    Region = 2,
    Country = 3,
}

export class OnboardingConfiguration {
    minimumUser : number;
    usersAtEachOpening : number;
    daysAtEachOpening : number;
    lastOpening : string ;
    openingType : OpeningType;

    constructor() 
    {
    	            this.minimumUser = null ;
                this.usersAtEachOpening = null ;
                this.daysAtEachOpening = null ;
                this.lastOpening = null;
                this.openingType = null;
        }
}

export enum OpeningType {
    Open = 0,
    MinimumAndStepOpen = 1,
    Close = 2,
}

export class TranslateObject {
    translationKey : string;
    replaceObject : any;

    constructor() 
    {
    	            this.translationKey = "" ;
                this.replaceObject = null;
        }
}

export class PagedResponseOfAppModalVM {
    items : AppModalVM[];
    totalItemsCount : number;

    constructor() 
    {
    	            this.items = [];
                this.totalItemsCount = null ;
        }
}

export class AppModalVM {
    identifier : string;
    attachmentUrl : string;
    title : LocalizedValue;
    text : LocalizedValue;
    actionText : LocalizedValue;
    actionUrl : string;
    isPublished : boolean;
    isEnabled : boolean;

    constructor() 
    {
    	            this.identifier = "" ;
                this.attachmentUrl = "" ;
                this.title = new LocalizedValue();
                this.text = new LocalizedValue();
                this.actionText = new LocalizedValue();
                this.actionUrl = "" ;
                this.isPublished = false ;
                this.isEnabled = false ;
        }
}

export class LocalizedEntity extends LocalizedValue {
    key : string;
    identifier : string;

    constructor() 
    {
    	        super();
		            this.key = "" ;
                this.identifier = "" ;
        }
}

export class PagedResponseOfLocalizedEntity {
    items : LocalizedEntity[];
    totalItemsCount : number;

    constructor() 
    {
    	            this.items = [];
                this.totalItemsCount = null ;
        }
}

export class BlockUserVM {
    blockedUserIdentifier : string;
    note : string;

    constructor() 
    {
    	            this.blockedUserIdentifier = "" ;
                this.note = "" ;
        }
}

export class BlockedUser extends BaseEntity {
    appUserIdentifier : string;
    blockedUserIdentifier : string;
    note : string;
    disabledData : DisabledData;
    lastStatus : BlockedUserStatusDetail;
    statusHistory : BlockedUserStatusDetail[];

    constructor() 
    {
    	        super();
		            this.appUserIdentifier = "" ;
                this.blockedUserIdentifier = "" ;
                this.note = "" ;
                this.disabledData = new DisabledData();
                this.lastStatus = new BlockedUserStatusDetail();
                this.statusHistory = [];
        }
}

export class BlockedUserStatusDetail {
    createdOn : string ;
    blockedUserStatus : BlockedUserStatus;

    constructor() 
    {
    	            this.createdOn = null;
                this.blockedUserStatus = null;
        }
}

export enum BlockedUserStatus {
    Blocked = 0,
    Unblocked = 1,
}

export class ChatRoomListVM {
    chatRoomIdentifier : string;
    experienceIdentifier : string;
    createdOn : string ;
    sender : ChatSender;
    lastMessage : ChatMessageVM;
    affinity : number;
    ghostingLevel : GhostingLevel;

    constructor() 
    {
    	            this.chatRoomIdentifier = "" ;
                this.experienceIdentifier = "" ;
                this.createdOn = null;
                this.sender = new ChatSender();
                this.lastMessage = new ChatMessageVM();
                this.affinity = null ;
                this.ghostingLevel = null;
        }
}

export class ChatMessageVM {
    createdOn : string ;
    identifier : string;
    chatRoomIdentifier : string;
    senderIdentifier : string;
    utcDatetime : string ;
    text : string;
    profileQuestion : ProfileQuestionAttached;
    textMessageAttached : TextMessageAttached;

    constructor() 
    {
    	            this.createdOn = null;
                this.identifier = "" ;
                this.chatRoomIdentifier = "" ;
                this.senderIdentifier = "" ;
                this.utcDatetime = null;
                this.text = "" ;
                this.profileQuestion = new ProfileQuestionAttached();
                this.textMessageAttached = new TextMessageAttached();
        }
}

export class ProfileQuestionAttached {
    matchIdentifier : string;
    replierIdentifier : string;
    imageUrl : string;
    affintyRate : number;
    name : string;
    birthDate : string ;
    question : string;
    answer : string;
    questionIndex : number;
    answerIndex : number;

    constructor() 
    {
    	            this.matchIdentifier = "" ;
                this.replierIdentifier = "" ;
                this.imageUrl = "" ;
                this.affintyRate = null ;
                this.name = "" ;
                this.birthDate = null;
                this.question = "" ;
                this.answer = "" ;
                this.questionIndex = null ;
                this.answerIndex = null ;
        }
}

export class TextMessageAttached {
    chatMessageIdentifier : string;
    senderInfo : TextIdentifier;
    text : string;

    constructor() 
    {
    	            this.chatMessageIdentifier = "" ;
                this.senderInfo = new TextIdentifier();
                this.text = "" ;
        }
}

export class PagedResponseOfBackofficeChatListVM {
    items : BackofficeChatListVM[];
    totalItemsCount : number;

    constructor() 
    {
    	            this.items = [];
                this.totalItemsCount = null ;
        }
}

export class BackofficeChatListVM {
    identifier : string;
    createdOn : string ;
    subscribers : ChatSender[];
    lastMessage : ChatMessage;
    isDeleted : boolean;
    ghostingLevel : GhostingLevel;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.subscribers = [];
                this.lastMessage = new ChatMessage();
                this.isDeleted = false ;
                this.ghostingLevel = null;
        }
}

export class BackofficeChatDetailVM {
    identifier : string;
    createdOn : string ;
    subscribers : ChatSender[];
    lastMessage : ChatMessage;
    isDeleted : boolean;
    ghostingLevel : GhostingLevel;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.subscribers = [];
                this.lastMessage = new ChatMessage();
                this.isDeleted = false ;
                this.ghostingLevel = null;
        }
}

export class DataDashAllUsersCountVM {
    usersCountMans : number;
    usersCountWomans : number;
    usersCountAll : number;

    constructor() 
    {
    	            this.usersCountMans = null ;
                this.usersCountWomans = null ;
                this.usersCountAll = null ;
        }
}

export class DataDashAllUsersCountHistoryVM {
    usersCountMans : number;
    usersCountWomans : number;
    usersCountAll : number;
    countDate : string ;
    userCountUntillDay : number;

    constructor() 
    {
    	            this.usersCountMans = null ;
                this.usersCountWomans = null ;
                this.usersCountAll = null ;
                this.countDate = null;
                this.userCountUntillDay = null ;
        }
}

export class DeleteAccountReasonVM {
    reason : string;
    tips : string;
    newsletterFutureUpdate : boolean;
    newsletterMoreUsersInMyArea : boolean;

    constructor() 
    {
    	            this.reason = "" ;
                this.tips = "" ;
                this.newsletterFutureUpdate = false ;
                this.newsletterMoreUsersInMyArea = false ;
        }
}

export class PagedResponseOfDeleteAccountReason {
    items : DeleteAccountReason[];
    totalItemsCount : number;

    constructor() 
    {
    	            this.items = [];
                this.totalItemsCount = null ;
        }
}

export class DeleteAccountReason extends BaseEntity {
    userIdentifier : string;
    reason : string;
    tips : string;
    newsletterFutureUpdate : boolean;
    newsletterMoreUsersInMyArea : boolean;

    constructor() 
    {
    	        super();
		            this.userIdentifier = "" ;
                this.reason = "" ;
                this.tips = "" ;
                this.newsletterFutureUpdate = false ;
                this.newsletterMoreUsersInMyArea = false ;
        }
}

export class ExperienceAffinityDetailVM {
    match : NewMatchVm;
    experience : ExperienceDetailVM;

    constructor() 
    {
    	            this.match = new NewMatchVm();
                this.experience = new ExperienceDetailVM();
        }
}

export class ConfirmAffinityVM {
    affinityIdentifier : string;

    constructor() 
    {
    	            this.affinityIdentifier = "" ;
        }
}

export class ExperienceConfirmAffinityVM extends ConfirmAffinityVM {
    experienceIdentifier : string;

    constructor() 
    {
    	        super();
		            this.experienceIdentifier = "" ;
        }
}

export class BaseMatchQuestionResponse {
    imageUrl : string;
    totalAffinity : number;
    affinity : number;
    matchStatus : ReplyStatus;
    isOverMinimumAffinity : boolean;
    isBombTriggered : boolean;

    constructor() 
    {
    	            this.imageUrl = "" ;
                this.totalAffinity = null ;
                this.affinity = null ;
                this.matchStatus = null;
                this.isOverMinimumAffinity = false ;
                this.isBombTriggered = false ;
        }
}

export class UserMatchQuestionResponse extends BaseMatchQuestionResponse {
    chatRoomIdentifier : string;
    otherPersonAlreadyMatched : boolean;

    constructor() 
    {
    	        super();
		            this.chatRoomIdentifier = "" ;
                this.otherPersonAlreadyMatched = false ;
        }
}

export class ExperienceManagementVM {
    hasAnyExperience : boolean;
    hasAnyApplication : boolean;
    canCreateNewExperience : boolean;

    constructor() 
    {
    	            this.hasAnyExperience = false ;
                this.hasAnyApplication = false ;
                this.canCreateNewExperience = false ;
        }
}

export class MyApplicationExperienceAffinityDetailVM extends ExperienceAffinityDetailVM {
    application : ExperienceApplication;

    constructor() 
    {
    	        super();
		            this.application = new ExperienceApplication();
        }
}

export class ExperienceApplication {
    appliedOn : string ;
    acceptedOn : string ;
    refusedOn : string ;
    status : ExperienceApplicationStatus;

    constructor() 
    {
    	            this.appliedOn = null;
                this.acceptedOn = null;
                this.refusedOn = null;
                this.status = null;
        }
}

export enum ExperienceApplicationStatus {
    Applied = 0,
    Accepted = 1,
    Refused = 2,
}

export class MatchDetailVm {
    matchIdentifier : string;
    appUserIdentifier : string;
    profileUrl : string;
    birthDate : string ;
    name : string;
    distanceMeters : number;
    education : string;
    jobTitle : string;
    biography : string;
    sexualOrientation : string;
    minimumAffinityRate : number;
    matchAffinityRate : number;
    answers : Answer[];

    constructor() 
    {
    	            this.matchIdentifier = "" ;
                this.appUserIdentifier = "" ;
                this.profileUrl = "" ;
                this.birthDate = null;
                this.name = "" ;
                this.distanceMeters = null ;
                this.education = "" ;
                this.jobTitle = "" ;
                this.biography = "" ;
                this.sexualOrientation = "" ;
                this.minimumAffinityRate = null ;
                this.matchAffinityRate = null ;
                this.answers = [];
        }
}

export class Answer extends BaseQuestion {
    answerIndex : number;
    affinityPercentage : number;
    imageUrl : string;
    publicImageUrl : string;
    answersPercentage : number[];
    isUnderMinimumAffinity : boolean;
    answerImageList : string[];

    constructor() 
    {
    	        super();
		            this.answerIndex = null ;
                this.affinityPercentage = null ;
                this.imageUrl = "" ;
                this.publicImageUrl = "" ;
                this.answersPercentage = [];
                this.isUnderMinimumAffinity = false ;
                this.answerImageList = [];
        }
}

export abstract class BaseReplyQuestionVm {
    questionIndex : number;
    answerIndex : number;
    answerText : string;

    constructor() 
    {
    	            this.questionIndex = null ;
                this.answerIndex = null ;
                this.answerText = "" ;
        }
}

export class ReplyMatchQuestionVm extends BaseReplyQuestionVm {
    matchIdentifier : string;

    constructor() 
    {
    	        super();
		            this.matchIdentifier = "" ;
        }
}

export class ExperienceReplyMatchQuestionVm extends ReplyMatchQuestionVm {
    experienceIdentifier : string;

    constructor() 
    {
    	        super();
		            this.experienceIdentifier = "" ;
        }
}

export class TakeOffMultipleAffinitiesVM {
    chatRoomIdentifiers : string[];

    constructor() 
    {
    	            this.chatRoomIdentifiers = [];
        }
}

export class PagedResponseOfBackofficeAffinityListVM {
    items : BackofficeAffinityListVM[];
    totalItemsCount : number;

    constructor() 
    {
    	            this.items = [];
                this.totalItemsCount = null ;
        }
}

export class BackofficeAffinityListVM {
    identifier : string;
    createdOn : string ;
    status : AffinityStatus;
    replies : AffinityReply[];
    isDeleted : boolean;
    isExperienceAffinity : boolean;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.status = null;
                this.replies = [];
                this.isDeleted = false ;
                this.isExperienceAffinity = false ;
        }
}

export enum AffinityStatus {
    Created = 0,
    Matched = 1,
    UnMatched = 2,
    Refused = -1,
}

export class AffinityReply {
    statusHistory : ReplyStatusHistory[];
    status : ReplyStatus;
    appUser : TextIdentifier;
    replier : TextIdentifier;
    answers : Answer[];
    bombTriggered : boolean;
    isOverMinimumAffinity : boolean;
    minimumAffinityPercentage : number;
    affinityPercentage : number;
    secondChanceSeenOn : string ;

    constructor() 
    {
    	            this.statusHistory = [];
                this.status = null;
                this.appUser = new TextIdentifier();
                this.replier = new TextIdentifier();
                this.answers = [];
                this.bombTriggered = false ;
                this.isOverMinimumAffinity = false ;
                this.minimumAffinityPercentage = null ;
                this.affinityPercentage = null ;
                this.secondChanceSeenOn = null;
        }
}

export class ReplyStatusHistory {
    createdOn : string ;
    status : ReplyStatus;

    constructor() 
    {
    	            this.createdOn = null;
                this.status = null;
        }
}

export class BackofficeAffinityDetailVM {
    identifier : string;
    createdOn : string ;
    isDeleted : boolean;
    statusHistory : AffinityStatusHistory[];
    status : AffinityStatus;
    replies : BackofficeAffinityReplyVM[];
    oldRepliesCausedByTryAgain : BackofficeAffinityReplyVM[];
    chatRoomIdentifier : string;
    experience : TextIdentifier;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.isDeleted = false ;
                this.statusHistory = [];
                this.status = null;
                this.replies = [];
                this.oldRepliesCausedByTryAgain = [];
                this.chatRoomIdentifier = "" ;
                this.experience = new TextIdentifier();
        }
}

export class AffinityStatusHistory {
    createdOn : string ;
    status : AffinityStatus;

    constructor() 
    {
    	            this.createdOn = null;
                this.status = null;
        }
}

export class BackofficeAffinityReplyVM {
    statusHistory : ReplyStatusHistory[];
    status : ReplyStatus;
    appUser : TextIdentifier;
    replier : TextIdentifier;
    answers : BackofficeAnswerVM[];
    bombTriggered : boolean;
    isOverMinimumAffinity : boolean;
    minimumAffinityPercentage : number;
    affinityPercentage : number;
    secondChanceSeenOn : string ;

    constructor() 
    {
    	            this.statusHistory = [];
                this.status = null;
                this.appUser = new TextIdentifier();
                this.replier = new TextIdentifier();
                this.answers = [];
                this.bombTriggered = false ;
                this.isOverMinimumAffinity = false ;
                this.minimumAffinityPercentage = null ;
                this.affinityPercentage = null ;
                this.secondChanceSeenOn = null;
        }
}

export class BackofficeAnswerVM {
    question : string;
    answers : AnswerVM[];
    minPercentage : number;
    answerIndex : number;
    affinityPercentage : number;
    imageUrl : string;
    publicImageUrl : string;
    answersPercentage : number[];
    isUnderMinimumAffinity : boolean;
    answerImageList : string[];

    constructor() 
    {
    	            this.question = "" ;
                this.answers = [];
                this.minPercentage = null ;
                this.answerIndex = null ;
                this.affinityPercentage = null ;
                this.imageUrl = "" ;
                this.publicImageUrl = "" ;
                this.answersPercentage = [];
                this.isUnderMinimumAffinity = false ;
                this.answerImageList = [];
        }
}

export class AnswerVM {
    answer : string;
    percentage : number;

    constructor() 
    {
    	            this.answer = "" ;
                this.percentage = null ;
        }
}

export class ExperienceSearchVM {
    categoriesIdentifiers : string[];
    title : string;
    orderByAscending : boolean;
    orderByMostPopular : boolean;

    constructor() 
    {
    	            this.categoriesIdentifiers = [];
                this.title = "" ;
                this.orderByAscending = false ;
                this.orderByMostPopular = false ;
        }
}

export class ExperienceEditVM {
    experienceIdentifier : string;
    categoryIdentifier : string;
    title : string;
    description : string;
    periodTitle : string;
    address : UserAddress;

    constructor() 
    {
    	            this.experienceIdentifier = "" ;
                this.categoryIdentifier = "" ;
                this.title = "" ;
                this.description = "" ;
                this.periodTitle = "" ;
                this.address = new UserAddress();
        }
}

export class PagedResponseOfExperienceBackofficeListVM {
    items : ExperienceBackofficeListVM[];
    totalItemsCount : number;

    constructor() 
    {
    	            this.items = [];
                this.totalItemsCount = null ;
        }
}

export class ExperienceBackofficeListVM {
    experienceIdentifier : string;
    createdOn : string ;
    creator : TextIdentifier;
    preferredCulture : string;
    category : ExperienceCategory;
    period : TitleDatePeriod;
    title : string;
    approvedData : ApprovedData;
    isActive : boolean;

    constructor() 
    {
    	            this.experienceIdentifier = "" ;
                this.createdOn = null;
                this.creator = new TextIdentifier();
                this.preferredCulture = "" ;
                this.category = new ExperienceCategory();
                this.period = new TitleDatePeriod();
                this.title = "" ;
                this.approvedData = new ApprovedData();
                this.isActive = false ;
        }
}

export class RefuseExperienceVm {
    reason : string;
    experienceIdentifier : string;

    constructor() 
    {
    	            this.reason = "" ;
                this.experienceIdentifier = "" ;
        }
}

export class PagedResponseOfInfluencerReferralVM {
    items : InfluencerReferralVM[];
    totalItemsCount : number;

    constructor() 
    {
    	            this.items = [];
                this.totalItemsCount = null ;
        }
}

export class InfluencerReferralVM {
    identifier : string;
    name : string;
    referralCode : string;
    utilityLinks : KeyValuePairOfStringAndString[];
    contactData : ContactData;
    isDisabled : boolean;

    constructor() 
    {
    	            this.identifier = "" ;
                this.name = "" ;
                this.referralCode = "" ;
                this.utilityLinks = [];
                this.contactData = new ContactData();
                this.isDisabled = false ;
        }
}

export class KeyValuePairOfStringAndString {
    key : string;
    value : string;

    constructor() 
    {
    	            this.key = "" ;
                this.value = "" ;
        }
}

export class ContactData {
    phoneNumber : string;
    emailAddress : string;

    constructor() 
    {
    	            this.phoneNumber = "" ;
                this.emailAddress = "" ;
        }
}

export class Country {
    name : string;
    alpha2Code : string;
    alpha3Code : string;
    numericCode : string;

    constructor() 
    {
    	            this.name = "" ;
                this.alpha2Code = "" ;
                this.alpha3Code = "" ;
                this.numericCode = "" ;
        }
}

export class ExtendedCountry extends Country {
    currencies : Currency[];
    languages : Language[];
    callingCodes : string[];
    countryNameTranslation : CountryTranslation;
    timezones : string[];
    topLevelDomains : string[];
    flagUrl : string;

    constructor() 
    {
    	        super();
		            this.currencies = [];
                this.languages = [];
                this.callingCodes = [];
                this.countryNameTranslation = new CountryTranslation();
                this.timezones = [];
                this.topLevelDomains = [];
                this.flagUrl = "" ;
        }
}

export class Currency {
    code : string;
    name : string;
    symbol : string;

    constructor() 
    {
    	            this.code = "" ;
                this.name = "" ;
                this.symbol = "" ;
        }
}

export class Language {
    iso639_1 : string;
    iso639_2 : string;
    name : string;
    nativeName : string;

    constructor() 
    {
    	            this.iso639_1 = "" ;
                this.iso639_2 = "" ;
                this.name = "" ;
                this.nativeName = "" ;
        }
}

export class CountryTranslation {
    de : string;
    es : string;
    fr : string;
    ja : string;
    it : string;
    br : string;
    pt : string;

    constructor() 
    {
    	            this.de = "" ;
                this.es = "" ;
                this.fr = "" ;
                this.ja = "" ;
                this.it = "" ;
                this.br = "" ;
                this.pt = "" ;
        }
}

export class NotificationVM {
    identifier : string;
    createdOn : string ;
    notificationType : NotificationType;
    title : string;
    body : string;
    route : string;
    targetUrl : string;
    chatImage : string;
    readOn : string ;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.notificationType = null;
                this.title = "" ;
                this.body = "" ;
                this.route = "" ;
                this.targetUrl = "" ;
                this.chatImage = "" ;
                this.readOn = null;
        }
}

export enum NotificationType {
    AffinityNearby = 0,
    NewAffinity = 1,
    GhostingAlert = 2,
    Info = 3,
    NewMessage = 4,
    AffinityRemoved = 5,
    ExperienceRefused = 6,
    ExperienceApproved = 7,
    ExperienceApplication = 8,
}

export class PremiumVM {
    identifier : string;
    title : LocalizedValue;
    description : LocalizedValue;
    promoText : LocalizedValue;
    includedServices : PremiumService[];
    totalPrice : number;
    androidStore : InfoSubscription;
    iosStore : InfoSubscription;
    stripe : InfoSubscription;

    constructor() 
    {
    	            this.identifier = "" ;
                this.title = new LocalizedValue();
                this.description = new LocalizedValue();
                this.promoText = new LocalizedValue();
                this.includedServices = [];
                this.totalPrice = null ;
                this.androidStore = new InfoSubscription();
                this.iosStore = new InfoSubscription();
                this.stripe = new InfoSubscription();
        }
}

export class PremiumService {
    imageUrl : string;
    title : LocalizedValue;
    description : LocalizedValue;

    constructor() 
    {
    	            this.imageUrl = "" ;
                this.title = new LocalizedValue();
                this.description = new LocalizedValue();
        }
}

export class InfoSubscription {
    subscriptionId : string;
    productId : string;

    constructor() 
    {
    	            this.subscriptionId = "" ;
                this.productId = "" ;
        }
}

export class ListStringContainerVM {
    list : string[];

    constructor() 
    {
    	            this.list = [];
        }
}

export class PremiumActiveVM {
    premiumPurchasedIdentifier : string;
    includedServices : PremiumService[];
    endDate : string ;
    willRenew : boolean;

    constructor() 
    {
    	            this.premiumPurchasedIdentifier = "" ;
                this.includedServices = [];
                this.endDate = null;
                this.willRenew = false ;
        }
}

export class CustomerInfoVM {
    provider : string;
    list : PurchaseListVM[];

    constructor() 
    {
    	            this.provider = "" ;
                this.list = [];
        }
}

export class PurchaseListVM {
    subscriptionId : string;
    productId : string;
    isActive : boolean;
    willRenew : boolean;
    expirationDate : string ;
    latestPurchaseDate : string ;

    constructor() 
    {
    	            this.subscriptionId = "" ;
                this.productId = "" ;
                this.isActive = false ;
                this.willRenew = false ;
                this.expirationDate = null;
                this.latestPurchaseDate = null;
        }
}

export class PremiumPurchasedListVM {
    identifier : string;
    appUserIdentifier : string;
    provider : string;
    providerReference : string;
    willRenew : boolean;
    isFree : boolean;
    activationPeriod : DatePeriod;
    subscriptionPeriod : SubscriptionPeriod;
    premium : Premium;

    constructor() 
    {
    	            this.identifier = "" ;
                this.appUserIdentifier = "" ;
                this.provider = "" ;
                this.providerReference = "" ;
                this.willRenew = false ;
                this.isFree = false ;
                this.activationPeriod = new DatePeriod();
                this.subscriptionPeriod = new SubscriptionPeriod();
                this.premium = new Premium();
        }
}

export class SubscriptionPeriod {
    years : number;
    months : number;
    days : number;
    hours : number;
    minutes : number;
    seconds : number;

    constructor() 
    {
    	            this.years = null ;
                this.months = null ;
                this.days = null ;
                this.hours = null ;
                this.minutes = null ;
                this.seconds = null ;
        }
}

export class Premium extends BaseEntity {
    androidStore : InfoSubscription;
    iosStore : InfoSubscription;
    stripe : InfoSubscription;
    title : LocalizedValue;
    description : LocalizedValue;
    promoText : LocalizedValue;
    includedServices : PremiumService[];
    price : Price;
    subscriptionPeriod : SubscriptionPeriod;

    constructor() 
    {
    	        super();
		            this.androidStore = new InfoSubscription();
                this.iosStore = new InfoSubscription();
                this.stripe = new InfoSubscription();
                this.title = new LocalizedValue();
                this.description = new LocalizedValue();
                this.promoText = new LocalizedValue();
                this.includedServices = [];
                this.price = new Price();
                this.subscriptionPeriod = new SubscriptionPeriod();
        }
}

export class Price {
    total : number;
    vat : number;
    taxableAmount : number;

    constructor() 
    {
    	            this.total = null ;
                this.vat = null ;
                this.taxableAmount = null ;
        }
}

export class PremiumToClaimVM {
    identifier : string;
    claimedOn : string ;
    activationPeriod : DatePeriod;
    subscriptionPeriod : SubscriptionPeriod;

    constructor() 
    {
    	            this.identifier = "" ;
                this.claimedOn = null;
                this.activationPeriod = new DatePeriod();
                this.subscriptionPeriod = new SubscriptionPeriod();
        }
}

export class PreviewQuestionVM {
    identifier : string;
    attachmentUrl : string;
    question : LocalizedValue;
    name : string;
    years : number;
    isPublished : boolean;

    constructor() 
    {
    	            this.identifier = "" ;
                this.attachmentUrl = "" ;
                this.question = new LocalizedValue();
                this.name = "" ;
                this.years = null ;
                this.isPublished = false ;
        }
}

export class PagedResponseOfPreviewQuestionVM {
    items : PreviewQuestionVM[];
    totalItemsCount : number;

    constructor() 
    {
    	            this.items = [];
                this.totalItemsCount = null ;
        }
}

export class StripeCardDetailVm {
    cardId : string;
    brand : string;
    country : string;
    currency : string;
    expMonth : number;
    expYear : number;
    dynamicLast4 : string;
    last4 : string;
    holder : string;

    constructor() 
    {
    	            this.cardId = "" ;
                this.brand = "" ;
                this.country = "" ;
                this.currency = "" ;
                this.expMonth = null ;
                this.expYear = null ;
                this.dynamicLast4 = "" ;
                this.last4 = "" ;
                this.holder = "" ;
        }
}

export class StripeSaveCardVm {
    userIdentifier : string;
    paymentMethodId : string;

    constructor() 
    {
    	            this.userIdentifier = "" ;
                this.paymentMethodId = "" ;
        }
}

export class SubscriptionCreateResponseVm {
    subscriptionId : string;
    clientSecret : string;

    constructor() 
    {
    	            this.subscriptionId = "" ;
                this.clientSecret = "" ;
        }
}

export class ProductVm {
    id : string;
    name : string;
    priceId : string;
    priceText : string;

    constructor() 
    {
    	            this.id = "" ;
                this.name = "" ;
                this.priceId = "" ;
                this.priceText = "" ;
        }
}

export class ConfirmSubscriptionPurchaseVm {
    paymentIdentifier : string;
    subscriptionIdentifier : string;
    premiumIdentifier : string;

    constructor() 
    {
    	            this.paymentIdentifier = "" ;
                this.subscriptionIdentifier = "" ;
                this.premiumIdentifier = "" ;
        }
}

export class SubscriptionCancelationModeVm {
    id : string;
    cancelAtPeriodEnd : boolean;

    constructor() 
    {
    	            this.id = "" ;
                this.cancelAtPeriodEnd = false ;
        }
}

export class TryAgainSummaryVM {
    canTryAgain : boolean;
    nextTryAgainAvailable : string ;
    tryAgainAvailableCount : number;
    description : string;
    isUserPremium : boolean;
    tryAgainAlreadyUsedForThisAffinity : boolean;

    constructor() 
    {
    	            this.canTryAgain = false ;
                this.nextTryAgainAvailable = null;
                this.tryAgainAvailableCount = null ;
                this.description = "" ;
                this.isUserPremium = false ;
                this.tryAgainAlreadyUsedForThisAffinity = false ;
        }
}

export class WaitingListUserModelVM {
    preferredCulture : string;
    phoneNumber : string;
    email : string;
    gender : Gender;
    userPosition : Address;
    fromUnavailablePlace : boolean;

    constructor() 
    {
    	            this.preferredCulture = "" ;
                this.phoneNumber = "" ;
                this.email = "" ;
                this.gender = null;
                this.userPosition = new Address();
                this.fromUnavailablePlace = false ;
        }
}

export enum Gender {
    All = 1,
    Male = 2,
    Female = 3,
}

export class PagedResponseOfWaitingListUserVM {
    items : WaitingListUserVM[];
    totalItemsCount : number;

    constructor() 
    {
    	            this.items = [];
                this.totalItemsCount = null ;
        }
}

export class WaitingListUserVM extends WaitingListUserModelVM {
    identifier : string;
    createdOn : string ;
    status : WaitingListUserStatus;

    constructor() 
    {
    	        super();
		            this.identifier = "" ;
                this.createdOn = null;
                this.status = null;
        }
}

export enum WaitingListUserStatus {
    Created = 0,
    Confirmed = 1,
    Registered = 2,
    Rejected = -1,
}

export class SystemConfiguration extends BaseEntity {
    termsConditionsUrl : LocalizedValue;
    privacyPolicyUrl : LocalizedValue;
    customerCareContact : ContactData;
    sexualOrientations : string[];
    questionsConfiguration : QuestionsConfiguration;
    blur : Blur;
    positionRange : RangeConfiguration;
    ageRange : AgeRangeConfiguration;
    ghostingConfiguration : GhostingConfiguration;
    limitConfiguration : LimitConfiguration;
    referralConfiguration : ReferralConfiguration;
    eventConfiguration : EventConfiguration;
    sites : LocalizedValue;

    constructor() 
    {
    	        super();
		            this.termsConditionsUrl = new LocalizedValue();
                this.privacyPolicyUrl = new LocalizedValue();
                this.customerCareContact = new ContactData();
                this.sexualOrientations = [];
                this.questionsConfiguration = new QuestionsConfiguration();
                this.blur = new Blur();
                this.positionRange = new RangeConfiguration();
                this.ageRange = new AgeRangeConfiguration();
                this.ghostingConfiguration = new GhostingConfiguration();
                this.limitConfiguration = new LimitConfiguration();
                this.referralConfiguration = new ReferralConfiguration();
                this.eventConfiguration = new EventConfiguration();
                this.sites = new LocalizedValue();
        }
}

export class QuestionsConfiguration {
    minimumRequiredQuestionsNumber : number;
    questionsNumber : number;

    constructor() 
    {
    	            this.minimumRequiredQuestionsNumber = null ;
                this.questionsNumber = null ;
        }
}

export class Blur {
    twentyFive : number;
    fifty : number;
    seventyFive : number;
    oneHundred : number;

    constructor() 
    {
    	            this.twentyFive = null ;
                this.fifty = null ;
                this.seventyFive = null ;
                this.oneHundred = null ;
        }
}

export class RangeConfiguration {
    step : number;
    min : number;
    max : number;

    constructor() 
    {
    	            this.step = null ;
                this.min = null ;
                this.max = null ;
        }
}

export class AgeRangeConfiguration {
    step : number;
    min : number;
    max : number;
    maxVisible : number;

    constructor() 
    {
    	            this.step = null ;
                this.min = null ;
                this.max = null ;
                this.maxVisible = null ;
        }
}

export class GhostingConfiguration {
    firstAlertHours : number;
    secondAlertHours : number;
    secondAlertNumberForBan : number;

    constructor() 
    {
    	            this.firstAlertHours = null ;
                this.secondAlertHours = null ;
                this.secondAlertNumberForBan = null ;
        }
}

export class LimitConfiguration {
    maxDailyProfile : number;
    maxAffinitiesAtTheSameTime : number;

    constructor() 
    {
    	            this.maxDailyProfile = null ;
                this.maxAffinitiesAtTheSameTime = null ;
        }
}

export class ReferralConfiguration {
    referralLink : string;

    constructor() 
    {
    	            this.referralLink = "" ;
        }
}

export class EventConfiguration {
    metersRadius : number;

    constructor() 
    {
    	            this.metersRadius = null ;
        }
}

export class BaseApiLoginResponse {
    identifier : string;
    username : string;
    role : string;
    token : string;
    refreshToken : string;
    refreshTokenExpiryTime : string ;

    constructor() 
    {
    	            this.identifier = "" ;
                this.username = "" ;
                this.role = "" ;
                this.token = "" ;
                this.refreshToken = "" ;
                this.refreshTokenExpiryTime = null;
        }
}

export class BaseCredential {
    username : string;
    password : string;

    constructor() 
    {
    	            this.username = "" ;
                this.password = "" ;
        }
}

export class LanguageCredential extends BaseCredential {
    preferredCulture : string;

    constructor() 
    {
    	        super();
		            this.preferredCulture = "" ;
        }
}

export class RefreshTokenResponse {
    refreshToken : string;
    refreshTokenExpiryTime : string ;

    constructor() 
    {
    	            this.refreshToken = "" ;
                this.refreshTokenExpiryTime = null;
        }
}

export class AuthResponse extends RefreshTokenResponse {
    token : string;

    constructor() 
    {
    	        super();
		            this.token = "" ;
        }
}

export class FilterVM {
    lookingFor : Gender;
    currentPosition : UserAddress;
    meters : number;
    ageRange : AgeRange;

    constructor() 
    {
    	            this.lookingFor = null;
                this.currentPosition = new UserAddress();
                this.meters = null ;
                this.ageRange = new AgeRange();
        }
}

export class AgeRange {
    minAge : number;
    maxAge : number;

    constructor() 
    {
    	            this.minAge = null ;
                this.maxAge = null ;
        }
}

export class LoggedUserVM {
    completeName : string;
    preferredCulture : string;
    emailAddress : string;
    identifier : string;
    username : string;
    role : string;
    token : string;
    address : Address;
    onBoardingCompleted : string ;
    profileCompleted : string ;
    profileOnHoliday : boolean;
    refreshToken : string;
    refreshTokenExpiryTime : string ;

    constructor() 
    {
    	            this.completeName = "" ;
                this.preferredCulture = "" ;
                this.emailAddress = "" ;
                this.identifier = "" ;
                this.username = "" ;
                this.role = "" ;
                this.token = "" ;
                this.address = new Address();
                this.onBoardingCompleted = null;
                this.profileCompleted = null;
                this.profileOnHoliday = false ;
                this.refreshToken = "" ;
                this.refreshTokenExpiryTime = null;
        }
}

export class LanguageCredentialWithLocation extends LanguageCredential {
    address : Address;

    constructor() 
    {
    	        super();
		            this.address = new Address();
        }
}

export class ProfileEditVM {
    username : string;
    noBlurQuestionImageUrls : string[];
    questions : ProfileQuestion[];
    profileData : ProfileData;
    personalData : PersonalData;
    searchPreferences : ProfileSearchPreferences;
    mailNotification : NotificationPreferences;
    smsNotification : NotificationPreferences;
    experienceCategoriesNotificationIds : string[];
    emailAddress : string;
    referralCode : string;
    profileOnHoliday : boolean;

    constructor() 
    {
    	            this.username = "" ;
                this.noBlurQuestionImageUrls = [];
                this.questions = [];
                this.profileData = new ProfileData();
                this.personalData = new PersonalData();
                this.searchPreferences = new ProfileSearchPreferences();
                this.mailNotification = new NotificationPreferences();
                this.smsNotification = new NotificationPreferences();
                this.experienceCategoriesNotificationIds = [];
                this.emailAddress = "" ;
                this.referralCode = "" ;
                this.profileOnHoliday = false ;
        }
}

export class ProfileQuestion extends BaseQuestion {
    answerImageList : string[];

    constructor() 
    {
    	        super();
		            this.answerImageList = [];
        }
}

export class BaseProfileData {
    sexualOrientation : string;
    showSexualOrientation : boolean;
    showAge : boolean;
    showDistance : boolean;
    minimumAffinityPercentage : number;
    showMinimumAffinityPercentage : boolean;

    constructor() 
    {
    	            this.sexualOrientation = "" ;
                this.showSexualOrientation = false ;
                this.showAge = false ;
                this.showDistance = false ;
                this.minimumAffinityPercentage = null ;
                this.showMinimumAffinityPercentage = false ;
        }
}

export class ProfileData extends BaseProfileData {
    jobTitle : string;
    education : string;
    gender : Gender;
    biography : string;

    constructor() 
    {
    	        super();
		            this.jobTitle = "" ;
                this.education = "" ;
                this.gender = null;
                this.biography = "" ;
        }
}

export class PersonalData {
    name : string;
    thumbnailUrl : string;
    birthDate : string ;

    constructor() 
    {
    	            this.name = "" ;
                this.thumbnailUrl = "" ;
                this.birthDate = null;
        }
}

export class SearchPreferences {
    radiusMeters : number;
    ageRange : AgeRange;

    constructor() 
    {
    	            this.radiusMeters = null ;
                this.ageRange = new AgeRange();
        }
}

export class ProfileSearchPreferences extends SearchPreferences {
    userPosition : UserAddress;
    lookingFor : Gender;

    constructor() 
    {
    	        super();
		            this.userPosition = new UserAddress();
                this.lookingFor = null;
        }
}

export class NotificationPreferences {
    disabled : boolean;
    newMatch : boolean;
    affinityRemoved : boolean;
    ghostingAlert : boolean;
    newMessage : boolean;
    promotion : boolean;

    constructor() 
    {
    	            this.disabled = false ;
                this.newMatch = false ;
                this.affinityRemoved = false ;
                this.ghostingAlert = false ;
                this.newMessage = false ;
                this.promotion = false ;
        }
}

export class ProfileSettingsVM {
    searchPreferences : ProfileSearchPreferences;
    contactData : ContactData;
    mailNotification : NotificationPreferences;
    smsNotification : NotificationPreferences;

    constructor() 
    {
    	            this.searchPreferences = new ProfileSearchPreferences();
                this.contactData = new ContactData();
                this.mailNotification = new NotificationPreferences();
                this.smsNotification = new NotificationPreferences();
        }
}

export class ProfileNotificationVM {
    mailNotification : NotificationPreferences;
    smsNotification : NotificationPreferences;

    constructor() 
    {
    	            this.mailNotification = new NotificationPreferences();
                this.smsNotification = new NotificationPreferences();
        }
}

export class SystemConfigurationVM {
    termsConditionsUrl : LocalizedValue;
    privacyPolicyUrl : LocalizedValue;
    customerCareContact : ContactData;
    sexualOrientations : string[];
    questions : QuestionsConfiguration;
    blur : Blur;
    positionRange : RangeConfiguration;
    ageRange : AgeRangeConfiguration;
    referralConfiguration : ReferralConfiguration;
    sites : LocalizedValue;

    constructor() 
    {
    	            this.termsConditionsUrl = new LocalizedValue();
                this.privacyPolicyUrl = new LocalizedValue();
                this.customerCareContact = new ContactData();
                this.sexualOrientations = [];
                this.questions = new QuestionsConfiguration();
                this.blur = new Blur();
                this.positionRange = new RangeConfiguration();
                this.ageRange = new AgeRangeConfiguration();
                this.referralConfiguration = new ReferralConfiguration();
                this.sites = new LocalizedValue();
        }
}

export class OnboardingConfigurationVM {
    minimumUser : number;
    currentUsers : number;
    isOnboardingOpened : boolean;
    temporaryClosed : boolean;
    nextOpen : string ;

    constructor() 
    {
    	            this.minimumUser = null ;
                this.currentUsers = null ;
                this.isOnboardingOpened = false ;
                this.temporaryClosed = false ;
                this.nextOpen = null;
        }
}

export class UpdateSettingsVM {
    showAge : boolean;
    showSexualOrientation : boolean;
    sexualOrientation : string;
    emailAddress : string;
    notification : NotificationPreferences;
    mailing : NotificationPreferences;
    experienceCategoriesNotification : string[];
    gender : Gender;

    constructor() 
    {
    	            this.showAge = false ;
                this.showSexualOrientation = false ;
                this.sexualOrientation = "" ;
                this.emailAddress = "" ;
                this.notification = new NotificationPreferences();
                this.mailing = new NotificationPreferences();
                this.experienceCategoriesNotification = [];
                this.gender = null;
        }
}

export class UpdateUserPositionVm {
    latitude : number;
    longitude : number;

    constructor() 
    {
    	            this.latitude = null ;
                this.longitude = null ;
        }
}

export class ConfirmOnboardingVM {
    name : string;
    birthDate : string ;
    gender : Gender;
    sexualOrientation : string;
    showSexualOrientation : boolean;
    lookingFor : Gender;
    showAge : boolean;
    ageRange : AgeRange;

    constructor() 
    {
    	            this.name = "" ;
                this.birthDate = null;
                this.gender = null;
                this.sexualOrientation = "" ;
                this.showSexualOrientation = false ;
                this.lookingFor = null;
                this.showAge = false ;
                this.ageRange = new AgeRange();
        }
}

export class UploadProfileQuestionVM {
    profileQuestion : ProfileQuestion;
    questionIndex : number;

    constructor() 
    {
    	            this.profileQuestion = new ProfileQuestion();
                this.questionIndex = null ;
        }
}

export class PagedResponseOfUserBasicInfoVM {
    items : UserBasicInfoVM[];
    totalItemsCount : number;

    constructor() 
    {
    	            this.items = [];
                this.totalItemsCount = null ;
        }
}

export class UserBasicInfoVM {
    identifier : string;
    username : string;
    name : string;
    age : number;
    gender : Gender;
    email : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.username = "" ;
                this.name = "" ;
                this.age = null ;
                this.gender = null;
                this.email = "" ;
        }
}

export class AppUserCompleteDetailVM {
    identifier : string;
    createdOn : string ;
    loginData : LoginDataVM;
    contactData : ContactData;
    personalData : PersonalDataVM;
    preferredCulture : string;
    disabledData : DisabledData;
    fcmId : string;
    profileData : ProfileDataVM;
    onBoardingCompleted : string ;
    profileCompleted : string ;
    lastLogin : string ;
    subscribedNewsletterOn : string ;
    profileOnHoliday : string ;
    questions : ProfileQuestionVM[];
    searchPreferences : ProfileSearchPreferencesVM;
    mailNotification : NotificationPreferences;
    smsNotification : NotificationPreferences;
    experienceCategoriesNotificationIds : string[];
    referralData : ReferralData;
    premium : PremiumStatus;
    affinitySummary : AffinitySummaryVM;
    ghostingSummary : GhostingSummary;
    lastMatchIdentifiers : string[];
    experienceSummaryVM : ExperienceSummaryVM;
    chatSummaryVM : ChatSummaryVM;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.loginData = new LoginDataVM();
                this.contactData = new ContactData();
                this.personalData = new PersonalDataVM();
                this.preferredCulture = "" ;
                this.disabledData = new DisabledData();
                this.fcmId = "" ;
                this.profileData = new ProfileDataVM();
                this.onBoardingCompleted = null;
                this.profileCompleted = null;
                this.lastLogin = null;
                this.subscribedNewsletterOn = null;
                this.profileOnHoliday = null;
                this.questions = [];
                this.searchPreferences = new ProfileSearchPreferencesVM();
                this.mailNotification = new NotificationPreferences();
                this.smsNotification = new NotificationPreferences();
                this.experienceCategoriesNotificationIds = [];
                this.referralData = new ReferralData();
                this.premium = new PremiumStatus();
                this.affinitySummary = new AffinitySummaryVM();
                this.ghostingSummary = new GhostingSummary();
                this.lastMatchIdentifiers = [];
                this.experienceSummaryVM = new ExperienceSummaryVM();
                this.chatSummaryVM = new ChatSummaryVM();
        }
}

export class LoginDataVM {
    username : string;
    confirmedOn : string ;

    constructor() 
    {
    	            this.username = "" ;
                this.confirmedOn = null;
        }
}

export class PersonalDataVM {
    name : string;
    birthDate : string ;

    constructor() 
    {
    	            this.name = "" ;
                this.birthDate = null;
        }
}

export class ProfileDataVM {
    gender : Gender;
    biography : string;
    sexualOrientation : string;
    showSexualOrientation : boolean;
    showAge : boolean;
    showDistance : boolean;
    minimumAffinityPercentage : number;
    showMinimumAffinityPercentage : boolean;

    constructor() 
    {
    	            this.gender = null;
                this.biography = "" ;
                this.sexualOrientation = "" ;
                this.showSexualOrientation = false ;
                this.showAge = false ;
                this.showDistance = false ;
                this.minimumAffinityPercentage = null ;
                this.showMinimumAffinityPercentage = false ;
        }
}

export class ProfileQuestionVM {
    image : string;
    question : string;
    answers : AnswerVM[];
    minPercentage : number;

    constructor() 
    {
    	            this.image = "" ;
                this.question = "" ;
                this.answers = [];
                this.minPercentage = null ;
        }
}

export class ProfileSearchPreferencesVM {
    lookingFor : Gender;
    addressFixed : boolean;
    latitude : number;
    longitude : number;
    radiusMeters : number;
    ageRange : AgeRange;

    constructor() 
    {
    	            this.lookingFor = null;
                this.addressFixed = false ;
                this.latitude = null ;
                this.longitude = null ;
                this.radiusMeters = null ;
                this.ageRange = new AgeRange();
        }
}

export class ReferralData {
    referralCode : string;
    redeemedOn : string ;
    referredBy : ReferredUser;
    referredUsers : ReferredUser[];

    constructor() 
    {
    	            this.referralCode = "" ;
                this.redeemedOn = null;
                this.referredBy = new ReferredUser();
                this.referredUsers = [];
        }
}

export class ReferredUser {
    type : string;
    referred : TextIdentifier;
    referredOn : string ;
    referralCode : string;

    constructor() 
    {
    	            this.type = "" ;
                this.referred = new TextIdentifier();
                this.referredOn = null;
                this.referralCode = "" ;
        }
}

export class PremiumStatus {
    activationPeriod : DatePeriod;
    premiumPurchasedIdentifier : string;

    constructor() 
    {
    	            this.activationPeriod = new DatePeriod();
                this.premiumPurchasedIdentifier = "" ;
        }
}

export class AffinitySummary {
    currentAffinities : number;
    maxAffinities : number;
    maxAffinityReached : boolean;

    constructor() 
    {
    	            this.currentAffinities = null ;
                this.maxAffinities = null ;
                this.maxAffinityReached = false ;
        }
}

export class AffinitySummaryVM extends AffinitySummary {
    totalAffinities : number;
    deletedAffinities : number;
    pendingAffinities : number;

    constructor() 
    {
    	        super();
		            this.totalAffinities = null ;
                this.deletedAffinities = null ;
                this.pendingAffinities = null ;
        }
}

export class GhostingSummary {
    currentGhosting : number;
    maxGhosting : number;
    maxGhostingReached : boolean;

    constructor() 
    {
    	            this.currentGhosting = null ;
                this.maxGhosting = null ;
                this.maxGhostingReached = false ;
        }
}

export class ExperienceSummaryVM {
    draft : number;
    approved : number;
    refused : number;
    deleted : number;

    constructor() 
    {
    	            this.draft = null ;
                this.approved = null ;
                this.refused = null ;
                this.deleted = null ;
        }
}

export class ChatSummaryVM {
    totalChats : number;
    activeChats : number;
    deletedChats : number;
    affinityChats : number;
    experienceChats : number;

    constructor() 
    {
    	            this.totalChats = null ;
                this.activeChats = null ;
                this.deletedChats = null ;
                this.affinityChats = null ;
                this.experienceChats = null ;
        }
}

export class InternalUserVM {
    preferredCulture : string;
    emailAddress : string;
    identifier : string;
    username : string;
    role : string;
    token : string;
    refreshToken : string;
    refreshTokenExpiryTime : string ;

    constructor() 
    {
    	            this.preferredCulture = "" ;
                this.emailAddress = "" ;
                this.identifier = "" ;
                this.username = "" ;
                this.role = "" ;
                this.token = "" ;
                this.refreshToken = "" ;
                this.refreshTokenExpiryTime = null;
        }
}

export class CreateOrUpdateQuestionCategoryVM {
    identifier : string;
    category : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.category = "" ;
        }
}

export class QuestionAndAnswerVM {
    identifier : string;
    title : LocalizedValue;
    body : LocalizedValue;
    category : TextIdentifier;

    constructor() 
    {
    	            this.identifier = "" ;
                this.title = new LocalizedValue();
                this.body = new LocalizedValue();
                this.category = new TextIdentifier();
        }
}

export class CreateOrUpdateQuestionAndAnswerVM {
    identifier : string;
    title : LocalizedValue;
    body : LocalizedValue;
    category : TextIdentifier;

    constructor() 
    {
    	            this.identifier = "" ;
                this.title = new LocalizedValue();
                this.body = new LocalizedValue();
                this.category = new TextIdentifier();
        }
}

export class SecondChanceVM {
    isPremium : boolean;
    limitReached : boolean;
    list : SecondChanceSummaryVM[];

    constructor() 
    {
    	            this.isPremium = false ;
                this.limitReached = false ;
                this.list = [];
        }
}

export class SecondChanceSummaryVM {
    identifier : string;
    appUserName : string;
    appUserAffinityPercentage : number;
    noBlurImage : string;
    needTryAgain : boolean;

    constructor() 
    {
    	            this.identifier = "" ;
                this.appUserName = "" ;
                this.appUserAffinityPercentage = null ;
                this.noBlurImage = "" ;
                this.needTryAgain = false ;
        }
}

export class PagedResponseOfFakeProfileListVM {
    items : FakeProfileListVM[];
    totalItemsCount : number;

    constructor() 
    {
    	            this.items = [];
                this.totalItemsCount = null ;
        }
}

export class FakeProfileListVM {
    identifier : string;
    name : string;
    age : number;
    gender : Gender;
    isPublished : boolean;

    constructor() 
    {
    	            this.identifier = "" ;
                this.name = "" ;
                this.age = null ;
                this.gender = null;
                this.isPublished = false ;
        }
}

export class FakeProfileDetailVM {
    identifier : string;
    questions : FakeProfileOwnerQuestionVM[];
    personalData : FakeProfilePersonalDataVM;
    profileData : FakeProfileData;
    searchPreferences : FakeProfileSearchPreferencesVM;
    isPublished : boolean;
    kmAway : number;

    constructor() 
    {
    	            this.identifier = "" ;
                this.questions = [];
                this.personalData = new FakeProfilePersonalDataVM();
                this.profileData = new FakeProfileData();
                this.searchPreferences = new FakeProfileSearchPreferencesVM();
                this.isPublished = false ;
                this.kmAway = null ;
        }
}

export class FakeProfileOwnerQuestionVM {
    answerImageList : string[];
    question : LocalizedValue;
    answers : LocalizedValue[];
    minPercentage : number;
    selectedImage : number;

    constructor() 
    {
    	            this.answerImageList = [];
                this.question = new LocalizedValue();
                this.answers = [];
                this.minPercentage = null ;
                this.selectedImage = null ;
        }
}

export class FakeProfilePersonalDataVM {
    name : string;
    birthDate : string ;

    constructor() 
    {
    	            this.name = "" ;
                this.birthDate = null;
        }
}

export class FakeProfileData extends BaseProfileData {
    jobTitle : string;
    education : string;
    gender : Gender;
    biography : LocalizedValue;

    constructor() 
    {
    	        super();
		            this.jobTitle = "" ;
                this.education = "" ;
                this.gender = null;
                this.biography = new LocalizedValue();
        }
}

export class FakeProfileSearchPreferencesVM {
    lookingFor : Gender;
    ageRange : AgeRange;

    constructor() 
    {
    	            this.lookingFor = null;
                this.ageRange = new AgeRange();
        }
}

export class CreateOrUpdateFakeProfileVM {
    identifier : string;
    personalData : FakeProfilePersonalDataVM;
    profileData : FakeProfileData;
    searchPreferences : FakeProfileSearchPreferencesVM;
    kmAway : number;

    constructor() 
    {
    	            this.identifier = "" ;
                this.personalData = new FakeProfilePersonalDataVM();
                this.profileData = new FakeProfileData();
                this.searchPreferences = new FakeProfileSearchPreferencesVM();
                this.kmAway = null ;
        }
}

export class UploadFakeProfileQuestionVM {
    fakeProfileIdentifier : string;
    profileQuestion : FakeProfileQuestion;
    questionIndex : number;

    constructor() 
    {
    	            this.fakeProfileIdentifier = "" ;
                this.profileQuestion = new FakeProfileQuestion();
                this.questionIndex = null ;
        }
}

export class FakeBaseQuestion {
    question : LocalizedValue;
    answers : LocalizedValue[];
    minPercentage : number;

    constructor() 
    {
    	            this.question = new LocalizedValue();
                this.answers = [];
                this.minPercentage = null ;
        }
}

export class FakeProfileQuestion extends FakeBaseQuestion {
    answerImageList : string[];

    constructor() 
    {
    	        super();
		            this.answerImageList = [];
        }
}

export class BaseEventModel extends BaseEntity {
    questions : ProfileQuestion[];
    searchPreferences : SearchPreferences;
    eventData : LiveEventData;
    published : PublishedData;

    constructor() 
    {
    	        super();
		            this.questions = [];
                this.searchPreferences = new SearchPreferences();
                this.eventData = new LiveEventData();
                this.published = new PublishedData();
        }
}

export class LiveEventData extends BaseProfileData {
    eventTitle : string;
    eventLocation : string;
    eventDate : string ;
    eventPosition : Address;
    note : LocalizedValue;
    description : LocalizedValue;
    maxPartecipant : number;
    maxFemale : number;
    maxMale : number;
    femaleCompleted : boolean;
    maleCompleted : boolean;
    eventCompleted : boolean;

    constructor() 
    {
    	        super();
		            this.eventTitle = "" ;
                this.eventLocation = "" ;
                this.eventDate = null;
                this.eventPosition = new Address();
                this.note = new LocalizedValue();
                this.description = new LocalizedValue();
                this.maxPartecipant = null ;
                this.maxFemale = null ;
                this.maxMale = null ;
                this.femaleCompleted = false ;
                this.maleCompleted = false ;
                this.eventCompleted = false ;
        }
}

export class PublishedData {
    publishedBy : TextIdentifier;
    publishOn : string ;

    constructor() 
    {
    	            this.publishedBy = new TextIdentifier();
                this.publishOn = null;
        }
}

export class LiveEventDataVM extends LiveEventData {
    eventIdentifier : string;

    constructor() 
    {
    	        super();
		            this.eventIdentifier = "" ;
        }
}

export class LiveEventSearchPreferencesVM extends SearchPreferences {
    eventIdentifier : string;

    constructor() 
    {
    	        super();
		            this.eventIdentifier = "" ;
        }
}

export class UploadEventQuestionVM extends UploadProfileQuestionVM {
    eventIdentifier : string;

    constructor() 
    {
    	        super();
		            this.eventIdentifier = "" ;
        }
}

export class PagedResponseOfBaseEventModel {
    items : BaseEventModel[];
    totalItemsCount : number;

    constructor() 
    {
    	            this.items = [];
                this.totalItemsCount = null ;
        }
}

export class WithDistanceResultOfEventMatchVm {
    result : EventMatchVm;
    distanceMeters : number;
    distanceMiles : number;

    constructor() 
    {
    	            this.result = new EventMatchVm();
                this.distanceMeters = null ;
                this.distanceMiles = null ;
        }
}

export class EventMatchVm extends BaseMatchVm {
    eventIdentifier : string;
    eventTitle : string;
    eventDescription : string;
    eventLocation : string;
    eventNote : string;

    constructor() 
    {
    	        super();
		            this.eventIdentifier = "" ;
                this.eventTitle = "" ;
                this.eventDescription = "" ;
                this.eventLocation = "" ;
                this.eventNote = "" ;
        }
}

export class ReplyEventQuestionVm extends BaseReplyQuestionVm {
    eventIdentifier : string;

    constructor() 
    {
    	        super();
		            this.eventIdentifier = "" ;
        }
}

export class LiveEventCheckedIn extends BaseEntity {
    appUserIdentifier : string;
    eventIdentifier : string;
    userName : string;
    gender : Gender;

    constructor() 
    {
    	        super();
		            this.appUserIdentifier = "" ;
                this.eventIdentifier = "" ;
                this.userName = "" ;
                this.gender = null;
        }
}

export class AppUserCheckedInVM extends LiveEventCheckedIn {
    genederName : string;

    constructor() 
    {
    	        super();
		            this.genederName = "" ;
        }
}

export class EventMatchResumeVM {
    matchIdentifier : string;
    eventIdentifier : string;
    imageUrl : string;
    eventTitle : string;
    date : string ;
    address : Address;

    constructor() 
    {
    	            this.matchIdentifier = "" ;
                this.eventIdentifier = "" ;
                this.imageUrl = "" ;
                this.eventTitle = "" ;
                this.date = null;
                this.address = new Address();
        }
}

export class EventMatchDetailVM extends EventMatchResumeVM {
    eventLocation : string;
    note : string;
    description : string;
    maxPartecipant : number;
    partecipantAmount : number;
    alreadyCheckedIn : boolean;
    answers : Answer[];
    affinityRate : number;

    constructor() 
    {
    	        super();
		            this.eventLocation = "" ;
                this.note = "" ;
                this.description = "" ;
                this.maxPartecipant = null ;
                this.partecipantAmount = null ;
                this.alreadyCheckedIn = false ;
                this.answers = [];
                this.affinityRate = null ;
        }
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class PagedRequestVM {
    paging: PagingFilter;
    sortBy: SortByParameter;
    filter: { [key: string]: string[] };

    constructor() {
        this.paging =  {
            currentPage : 1,
            itemsPerPage : 15,
            skip : 0,
            take : 15,
        };
        this.sortBy = null;
        this.filter = {};
    }
}

export class PagedRequestWithIdentifierVM extends PagedRequestVM {
    identifier : string;

    constructor() 
    {
        super();
        this.identifier = "" ;
    }
}

export class PagingFilter {
    currentPage: number;
    itemsPerPage: number;
    skip: number;
    take: number;

    constructor() {
        this.currentPage = null;
        this.itemsPerPage = null;
        this.skip = null;
        this.take = null;
    }
}

export class SortByParameter {
    propertyName: string;
    ascending: boolean;

    constructor() {
        this.propertyName = "";
        this.ascending = false;
    }
}